<template>
    <div style="padding:10px;">
        <div>
            <div style="margin-bottom:4px;font-size:12px;">
                <h1 style="margin-right:6px;font-size:18px; font-weight:500; margin-bottom:10px;">商品</h1>
                <el-button size="mini" icon="el-icon-download" @click="downloadqc" type="primary">下载商品资料模板</el-button>
                <el-button size="mini" icon="el-icon-folder-add" @click="exportQc('导入商品资料')"
                    type="primary">导入商品资料</el-button>
            </div>
            <hr style='background-color:#409eff; height:1px; border:none;'>
            <div style="height:10px;"></div>
        </div>
        <el-dialog :title="title" :visible.sync="dialogVisible" width="30%">
            <initDataUpload :errorUrl="'GSPgoods/exportGoodLicenseFail'" :url="url" :importType="importType" @fileSuccess='fileSuccess' @closeExcel="closeExcel">
            </initDataUpload>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'initDataGl',
    components: {},
    data() {
        return {
            dialogVisible: false,// 弹窗
            requesUrl: '',// 请求地址
            limit: 2,// 上传文件数量
            fileList: [],// 上传文件列表
            importType: '',// 导入类型
            url: '',// 导入地址
            title: "",// 弹窗标题
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 触发组件的提交
        fileSuccess(val) {
        },
        // 关闭弹窗
        closeExcel(refresh) {
            this.dialogVisible = false
            // if (refresh) this.getDataList()
        },
        // 商品
        downloadqc() {
            window.location.href = `${this.$store.getters.getConfig.requestUrl}/GSPgoods/downloadImportGoodExcel`
        },
        // 商品
        exportQc(title) {
            this.title = title
            this.importType = 'importGoodinit'
            this.dialogVisible = true
        },

    },
    created() {
        this.requesUrl = this.$store.getters.getConfig.requestUrl; // 获取请求地址
    },
    mounted() { }
};
</script>
<style scoped></style>s